import { useQuery } from '@tanstack/react-query';
import { format, parseISO } from 'date-fns';
import { getLastUpdate, getLastUpdateNegotiations } from '../../../../services/ProdutoService_ts';

const QUERY_BY_VARIANT = {
  pricing: { key: 'last-update', fn: getLastUpdate },
  negotiations: { key: 'last-update-negotiations', fn: getLastUpdateNegotiations },
};

export const useDataUltimaIntegracao = (variant = 'pricing') => {
  const { key, fn } = QUERY_BY_VARIANT[variant] ?? QUERY_BY_VARIANT.pricing;

  const { data, isLoading } = useQuery({
    queryKey: [key],
    queryFn: fn,
    retry: false,
  });

  return {
    data,
    isLoading,
    parsedDate: data?.lastExecutionDate ? format(parseISO(data?.lastExecutionDate ?? ''), 'dd/MM/yyy, HH:mm') : null,
  };
};
